<template>
    <div>
      <v-card>
        <!-- <v-card-title>
          <span>{{ title }}</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="close()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title> -->
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              md="5"
            >
                <v-select
                  v-model="selected_variator"
                  :items="variators"
                  item-text="name"
                  label="Seleccione un Variador"
                  return-object
                >
                </v-select>
            </v-col>
          </v-row>
          <v-row v-if="!realTime">
            <v-col>
              <v-card>
                <v-card-text class="mb-2">
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <koiote-date-picker
                        dateLabel="Fecha Inicio"
                        hourLabel="Hora Inicio"
                        @cambio="cambio_fecha_hora_inicio"
                      ></koiote-date-picker>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <koiote-date-picker
                        dateLabel="Fecha Fin"
                        hourLabel="Hora Fin"
                        @cambio="cambio_fecha_hora_fin"
                      ></koiote-date-picker>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      class="d-flex align-self-center"
                    >
                      <v-btn
                        @click="getVariatorsVariables"
                        :disabled="disabledBtn"
                      >
                          Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card>
        <new-line-chart v-if="loaded" :chartData="chart_data"></new-line-chart>
      </v-card>

      <v-card v-if="loaded">
          <v-card-title>
            Datos Históricos
            <v-spacer></v-spacer>
            <v-btn @click="downloadData">Descargar</v-btn>
          </v-card-title>
          
          <v-data-table
            :headers="tableHeaders"
            :items="tableData"
            :items-per-page="10"
            class="elevation-1"
          >
          </v-data-table>
        </v-card>
    </div>
  </template>
  
  <script>
  import moment from "moment-timezone";
  import * as XLSX from "xlsx";
  
  import { mapGetters, mapActions } from "vuex";
  
  import NewLineChart from "@/components/utils/NewLineChart.vue";
  import KoioteDatePicker from "@/components/utils/KoioteDatePicker.vue";
  
  export default {
    components: {
      NewLineChart,
      KoioteDatePicker,
    },
  
    props: {
      title: String,
      realTime: Boolean,
      address: String,
    },
  
    data() {
      return {
        loading: true,
        loaded:false,
        
        available_variables: [],
        selected_variables: [],
  
        // chartOptionsMutado: {},
        chart_data: {},

        tableData: [],
        tableHeaders: [
          { text: 'Fecha', value: 'timestamp' },
          { text: 'Voltage', value: 'voltage' },
          { text: 'Frecuencia', value: 'frecuencia' },
          { text: 'Velocidad Motor', value: 'motor_speed' },
          { text: 'Energía acumulada', value: 'energia_acumulada' },
          { text: 'Corriente de salida', value: 'corriente_salida' }
        ],
  
  
        variators: [],
        selected_variator: null,
  
        variables_dialog: false,
        variables: [],
        fecha_hora_inicio: null,
        fecha_hora_fin: null,
      };
    },
  
    computed: {

      disabledBtn () {
        return this.fecha_hora_fin == null || this.fecha_hora_inicio == null || this.selected_variator == null;
      },
  
      table_header() {
        const headers = this.selected_variables?.map((v) => ({ text: `${v?.name} Variador ${v?.variator_id}`, value: `${v?.id}` }));
        headers.unshift({ text: "Fecha", value: "read_at" });
        return headers;
      },
    
    },
  
    methods: {
      ...mapGetters(["actualPage"]),
      // ...mapGetters("utils", ["getInitDateFilter", "getEndDateFilter"]),
      ...mapGetters("nodered", ["getHistoryValues"]),
      ...mapActions(["getData", "setSelectedPage", "loadPages"]),


      //recoger variables del variador seleccionado
      async getVariatorsVariables() {
        this.loaded=false;
        this.chart_data=[]
        this.tableData=[]
        const params = {
            id: this.selected_variator.id,
            initDate: this.fecha_hora_inicio,
            endDate: this.fecha_hora_fin,
        }

        const { resultado, groupedRead_at} = await this.getData({
          path: `variadores/variables/history/chart`,
          params: params,
        });
        console.group("groupedRead_at")
        console.log(groupedRead_at)
        console.groupEnd()
        // console.log(chartData);
        this.chart_data = resultado;

        //dividimos el eje y en 2
        this.chart_data.datasets.map(dataset => {
          if (dataset.variator_variable_id === 12) {
            dataset.yAxisID = "y2"
          } else {
            dataset.yAxisID = "y1"
          }
          return dataset;
        });

        //generamos el data table con los datos del backend
        if (groupedRead_at.length > 0) {
          // console.group("data")
          let last_timestamp = null
          let last_voltage = null
          let last_frecuencia = null
          let last_motor_speed = null
          let last_energia_acumulada = null
          let last_corriente_salida = null

          groupedRead_at.forEach(data => {
            const timestamp = moment(data.read_at).format("YYYY-MM-DD HH:mm:ss");

            const voltage = (data.voltage !== null && data.voltage !== undefined) || data.voltage === 0 ? data.voltage : last_voltage;
            const frecuencia = (data.frecuencia !== null && data.frecuencia !== undefined) || data.frecuencia === 0 ? data.frecuencia : last_frecuencia;
            const motor_speed = (data.motor_speed !== null && data.motor_speed !== undefined) || data.motor_speed === 0 ? data.motor_speed : last_motor_speed;
            const energia_acumulada = (data.energia_acumulada !== null && data.energia_acumulada !== undefined) || data.energia_acumulada === 0 ? data.energia_acumulada : last_energia_acumulada;
            const corriente_salida = (data.corriente_salida !== null && data.corriente_salida !== undefined) || data.corriente_salida === 0 ? data.corriente_salida : last_corriente_salida;

            last_timestamp = timestamp;
            last_voltage = voltage;
            last_frecuencia = frecuencia;
            last_motor_speed = motor_speed;
            last_energia_acumulada = energia_acumulada;
            last_corriente_salida = corriente_salida;

            this.tableData.push({ timestamp, voltage, frecuencia, motor_speed, energia_acumulada, corriente_salida });
          });

        }
        
        // console.log(this.chart_data);
        // console.log(groupedRead_at);
        this.loaded=true

      },
  
      downloadData() {
        if (this.tableHeaders.length > 1) {
          const ws = XLSX.utils.aoa_to_sheet([this.tableHeaders?.map((header) => header.text)]);
          this.tableData.forEach((item) => {
            const row = this.tableHeaders?.map((header) => (item[header.value] !== null ? item[header.value] : ""));
            XLSX.utils.sheet_add_aoa(ws, [row], { origin: -1 });
          });
          const wb = XLSX.utils.book_new();
  
          XLSX.utils.book_append_sheet(wb, ws, "Data");
          const file_name = "datos_variables_seleccionadas";
          XLSX.writeFile(wb, file_name + ".xlsx");
        }
      },
  
      close() {
        this.$emit("close");
      },
  
      onRenderComplete() {
        this.loading = false;
      },

      cambio_fecha_hora_inicio(payload){
        this.fecha_hora_inicio = payload;
      },
      cambio_fecha_hora_fin(payload){
        this.fecha_hora_fin = payload;
      }
    },
  
    async created() {
      await this.loadPages();
      this.setSelectedPage(this.$route.params.page_index);
  
      //recoger variadores de bbdd
      const { variadores } = await this.getData({
        path: "variadores/",
      });
      // console.log(variadores);
      this.variators = variadores;
  
      // if (this.address) {
      //   this.selected_variables = [this.available_variables.find((v) => v.formatted_address == this.address)];
      // }
    },
  };
  </script>
  
  <style>
  .scrollable-card {
    max-height: 600px;
    overflow-y: auto;
  }
  </style>
  